/** This feature's routes, as constants. */

export const CONNECTOR_FILES_PATHS = {
  exchange: "/integration/fichiers",
} as const;
